module.exports = __webpack_public_path__ + "images/7be08bb9b3fc2f2fa261736eef9f877e.svg";